import { render, staticRenderFns } from "./EditWinnerDialog.vue?vue&type=template&id=6cf2ec31&scoped=true"
import script from "./EditWinnerDialog.vue?vue&type=script&lang=js"
export * from "./EditWinnerDialog.vue?vue&type=script&lang=js"
import style0 from "./EditWinnerDialog.vue?vue&type=style&index=0&id=6cf2ec31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf2ec31",
  null
  
)

export default component.exports